import React from 'react';
import ListIcon from '../../assets/images/icons/list.svg';
import StarIcon from '../../assets/images/icons/star.svg';
import featuredImage from '../../assets/images/featured_feature.png';
import mapFeatureImage from '../../assets/images/map_feature.jpg';
import DocumentIcon from '../../assets/images/icons/document.svg';
import printFeatureImage from '../../assets/images/print_feature.jpg';
import RadioIcon from '../../assets/images/icons/radio.svg';
import SocialIcon from '../../assets/images/icons/social.svg';
import TicketIcon from '../../assets/images/icons/ticket.svg';
import GraphIcon from '../../assets/images/icons/graph.svg';
import MegaphoneIcon from '../../assets/images/icons/megaphone.svg';
import ShareIcon from '../../assets/images/icons/share.svg';
import LocationIcon from '../../assets/images/icons/location.svg'
import PublisherIcon from '../PublisherIcon';

const PaidFeaturesSummary = (props) => {
  const {
    featuringPublisher,
    availablePublishersCount,
    partnerExports,
    isValidForOriginPublisher,
    topPublishers,
    scrollAllPublishers
  } = props;
  const publisherName = featuringPublisher ? featuringPublisher.get('name') : '';
  const features = (partnerExports && isValidForOriginPublisher) ? partnerExports.toJS() : {};
  let featuresHeight = 460;

  if (features.print) {
    featuresHeight += 160;
  }

  const seeMorePublishersCount = availablePublishersCount - 15;
  
  return (
    <div className="features-summary">
      <div className="title">
        Premium Features
      </div>
      <div className="list">
        <ul style={{height: featuresHeight + 'px'}}>
          <li><img className="svgIcon" src={ListIcon}/> An event listing on {publisherName}.</li>
          <li><img className="svgIcon" src={StarIcon}/> Featured position on {publisherName}.
            <img className="featureImage" src={featuredImage}/>
          </li>
          <li><img className="svgIcon" src={LocationIcon}/> Map pin enlarged placement on the calendar.
            <img className="featureImage" src={mapFeatureImage}/>
          </li>
          {features.print &&
          <li><img className="svgIcon" src={DocumentIcon}/> Print featured placement the week of your event.
            <img className="featureImage" src={printFeatureImage}/>
          </li>}
          {featuringPublisher && featuringPublisher.get('radio_enabled') &&
          <li><img className="svgIcon" src={RadioIcon}/> Your event played out over the radio.</li>}
          <li><img className="svgIcon" src={SocialIcon}/> Social - Unlimited social reposting.</li>
          <li><img className="svgIcon" src={TicketIcon}/> Ticketing - Use ours, or add your own.</li>
          <li><img className="svgIcon" src={GraphIcon}/> Detailed event progress report.</li>
          <li><img className="svgIcon" src={MegaphoneIcon}/> Promotion lasts until your event ends.</li>
          <li><img className="svgIcon" src={ShareIcon}/> Syndicate your event to <span
            className="bolder">{availablePublishersCount}</span> relevant and targeted event listings sites.
          <div className="publisherMiniList">
            {topPublishers.map((publisher) => {
              return (
                <PublisherIcon publisher={publisher} key={`publisher-icon-${publisher.get('id')}`} fixedHeight='45px'
                  omitName={true}/>);
            })}
          </div>
          {seeMorePublishersCount > 0 &&
            <span className="seeMore" onClick={() => scrollAllPublishers()}>+ {seeMorePublishersCount} more</span>}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default PaidFeaturesSummary;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/snapsell/PaidFeaturesSummary.jsx